import { Link } from "react-router-dom";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import newsLetterImg from "../../assets/images/newsletter.png";
import Button from "@mui/material/Button";
import { IoMailOutline } from "react-icons/io5";
import Banners from "../banners/index";
import { useEffect, useState } from "react";
import { fetchDataFromApi } from "../../utils/api";
import {
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaGooglePlay,
} from "react-icons/fa";
import SabbaFarmLogo from "../../assets/images/sabba krish logo.png";
// import { Image } from "@mui/icons-material";
const Footer = () => {
  const [bannerList, setBannerList] = useState([]);
  const quicklinks = [
    // {id:0, label: "About Us", link: "/about-us" },
    // { id:1,label: "Reach Us", link: "/reach-us" },
    // { id:2,label: "Media Links", link: "/media-links" },
    { id: 1, label: "Privacy Policy", link: "/privacy" },
    { id: 2, label: "Return & Refund Policy", link: "/returnpolicy" },
    { id: 3, label: "Terms of Service", link: "/legalterms" },
    // { id:6, label: "Careers", link: "/careers" },
    // { id:7, label: "Shipping/Delivery Policy", link: "/shipping-delivery-policy" },
    // { id:8, label: "FAQ", link: "/faq" },
    // { id:9, label: "Sitemap", link: "/sitemap" }
  ];

  return (
    <footer className="bg-gradient-to-b from-[#2C3B36] to-[#1a2823] text-gray-300 mt-3 ">
      {/* Main Footer */}
      <div className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-1">
              <div className="mb-6">
                <img
                  src={SabbaFarmLogo}
                  alt="SabbaFarm Logo"
                  className="w-40 h-auto mb-4 filter brightness-0 invert"
                />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                SabbaFarm (also known as Sabba Farm) (Sri santhosh sowjanya
                agencies) incorporated in the year 2006 is India's No.1 Online
                Agri Shop for each and every product required for agriculture -
                Seeds, Fertilizers, Pesticides, Plant Growth Regulators,
                Irrigation and Farming Tools and Equipment with Guaranteed
                Market's Best Price, Customer Support and Free Home Delivery
                throughout India.
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-span-1 md:col-span-1">
              <h3 className="text-[#4CAF50] text-xl font-bold mb-6 relative">
                Quick Links
                <span className="absolute bottom-0 left-0 w-12 h-1 bg-[#4CAF50] rounded-full"></span>
              </h3>
              <ul className="space-y-3">
                {quicklinks.map((l) => (
                  <li key={l.id}>
                    <Link
                      to={l.link}
                      className="text-gray-400 hover:text-white transition-colors duration-300 text-sm flex items-center group"
                    >
                      <span className="w-1 h-1 bg-[#4CAF50] rounded-full mr-2 group-hover:w-2 transition-all duration-300"></span>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Section */}
            <div className="col-span-1 md:col-span-1">
              <h3 className="text-[#4CAF50] text-xl font-bold mb-6 relative">
                Contact Us
                <span className="absolute bottom-0 left-0 w-12 h-1 bg-[#4CAF50] rounded-full"></span>
              </h3>
              <div className="space-y-6">
                <div>
                  <p className="text-gray-400 mb-2 text-sm">
                    Missed Call To Order:
                  </p>
                  <Link
                    to="tel:9866113858"
                    className="bg-[#4CAF50] hover:bg-[#45a049] text-white px-6 py-2 rounded-full inline-block transition-colors duration-300 text-sm font-medium shadow-lg hover:shadow-xl"
                  >
                    9866113858
                  </Link>
                </div>
                <div>
                  <p className="text-gray-400 mb-2 text-sm">Whatsapp:</p>
                  <Link
                    to="https://wa.me/9171749999"
                    className="bg-[#4CAF50] hover:bg-[#45a049] text-white px-6 py-2 rounded-full inline-block transition-colors duration-300 text-sm font-medium shadow-lg hover:shadow-xl"
                  >
                    9171749999
                  </Link>
                </div>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="col-span-1 md:col-span-1">
              <h3 className="text-[#4CAF50] text-xl font-bold mb-6 relative">
                Connect With Us
                <span className="absolute bottom-0 left-0 w-12 h-1 bg-[#4CAF50] rounded-full"></span>
              </h3>
              <div className="flex space-x-4">
                <Link
                  to="https://www.instagram.com/happyfarmpsp"
                  className="bg-gray-800 hover:bg-[#4CAF50] text-white p-3 rounded-full transition-colors duration-300"
                >
                  <FaInstagram className="w-5 h-5" />
                </Link>
                <Link
                  to="https://www.facebook.com/happyfarmpsp/"
                  className="bg-gray-800 hover:bg-[#4CAF50] text-white p-3 rounded-full transition-colors duration-300"
                >
                  <FaFacebook className="w-5 h-5" />
                </Link>
                <Link
                  to="https://wa.me/9171749999"
                  className="bg-gray-800 hover:bg-[#4CAF50] text-white p-3 rounded-full transition-colors duration-300"
                >
                  <FaWhatsapp className="w-5 h-5" />
                </Link>
              </div>

              {/* Get the App */}
              <div className="mt-6">
                <a
                  href="https://play.google.com/store/apps/details?id=app.sabba.farm&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-[#4CAF50] hover:bg-[#45a049] text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg hover:shadow-xl transition-colors duration-300"
                >
                  <FaGooglePlay className="w-5 h-5 mr-2" />
                  Get our app on Play Store
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-[#1a2823] py-6 border-t border-gray-800">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              Copyright © 2006 Sri santhosh sowjanya agencies
            </p>
            <div className="flex space-x-4">
              <Link
                to="/privacy"
                className="text-gray-400 hover:text-white text-sm transition-colors duration-300"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-gray-400 hover:text-white text-sm transition-colors duration-300"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
